import { multipart } from '../../api'
import { MultipartBody } from '../../api/types'
import { SimpleApi } from '../../api-action'
import { SignupJunkLoverResponse } from './types'

export const signupJunkLoverApi =
  (url: string) =>
  (body: MultipartBody): SimpleApi<SignupJunkLoverResponse> =>
    multipart(url, body)
